var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    transform: "translate(0.5, 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    "data-color": "color-2",
    d: "M10.493,14.389l2.362,5.863a2,2,0,0,1-1.108,2.6h0a2,2,0,0,1-2.6-1.108L5.511,12.8",
    fill: "none",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    d: "M18.309,1.119,3,6A2.82,2.82,0,0,0,1,9a2.82,2.82,0,0,0,2,3l15.309,4.881",
    fill: "none",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19,
    cy: 9,
    rx: 4,
    ry: 8,
    fill: "none",
    stroke: "black",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeLinejoin: "miter"
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    "data-stroke": "none",
    d: "M20,9a2.99,2.99,0,0,0-2.658-2.966A12.554,12.554,0,0,0,17,9a12.554,12.554,0,0,0,.342,2.966A2.99,2.99,0,0,0,20,9Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.5c1dfcde3afa3a6c64676b0daf3fe69a.svg";
export { ForwardRef as ReactComponent };